import { StyleRules } from '@material-ui/core';
import { Overrides } from '@material-ui/core/styles/overrides';
interface ComponentNameToClassKey extends Overrides {
  MuiAutocomplete?: Partial<StyleRules>;
}
const MuiAutocomplete: ComponentNameToClassKey['MuiAutocomplete'] = {
  input: {
    height: '2.4rem;',
  },
};

export default MuiAutocomplete;
